import { useNavigate } from "react-router-dom";
import Logo from "../design/Logo";
import CardText from "../design/CardText";
import CardSectionNotOnClick from "../design/CardSectionNotOnClick";

const Vokatoktok = () => {
  const textArray = ["보", "카", "톡", "톡"];
  const cardData = {
    title: "",
    items: [
      "'보카톡톡'은 자동 메타인지를 적용한 특허받은 학습 로직을 통해 학습자에게 최적화된 맞춤형 학습을 제공합니다.",
      "이 시스템은 학습자가 아는 단어와 모르는 단어를 자동으로 분류하고, 학습 과정에서 자주 틀린 단어를 집중적으로 연습하고 테스트하여 쉽게 장기 기억으로 전환하도록 돕습니다.",
      "또한, 학습자의 능력치에 따라 학습 방법이 자동으로 조정되어 경계선에 있는 학생들도 효과적인 학습 결과를 얻을 수 있도록 설계되었습니다.",
      "이러한 혁신적인 로직을 통해 '보카톡톡'은 모든 학습자에게 학습 결과를 보장합니다.",
      "또한, 테스트나 연습할 때 즐겁게 학습할 수 있도록 다양한 테스트를 구현합니다.",
    ],
  };

  const cardData2 = {
    title: "보카톡톡의 학습특징",
    items: [
      "보카톡톡의 특허 받은 자동 메타인지를 통한 아는 단어와 모르는 단어를 자동으로 분류하여 100% 개인 맞춤 학습을 진행합니다.",
      "개인별 학습 능력치를 다른 실시간 체크하여 학습 능력치에 따라 개인별 맞춤 학습 로직으로 학습을 합니다. (특허등록)",
      "기본 한 세트학습(영어+단어뜻, 영어, 단어뜻)을 통해 학생들 학습 능력에 따라 학습 방법을 실시간으로 달리하는 학습을 합니다. (특허등록)",
      "연습 → 매칭 학습(즐거운 학습) → 테스트 → 완료 진행을 통한 완전학습을 진행합니다. 완전 학습 이상의 학습 결과를 보이고 있습니다.",
    ],
  };

  const navigate = useNavigate();

  const cardSectionData1 = {
    title: "아는 단어 복습",
    description: "복습을 통한 완전 학습!",
    emoji: "📔",
    listItems: [
      "보카 톡톡의 특허 받은 자동 메타인지를 통한 아는 단어를 매일 100개의 단어를 복습 테스트하여 장기억화 시킴",
      "완전 학습이 될(100점) 때까지 학습을 진행합니다.",
    ],
  };

  const cardSectionData2 = {
    title: "선택 학습",
    description: "내가 원하는 부분을 선택적으로",
    emoji: "✅",
    listItems: [
      "파닉스부터 토익 단어까지 수준별 단어를 학습할 수 있습니다.",
      "객관식, 주관식 단어를 학년 별 교과 내용과 기타 단어장의 단어들을 학습",
      "특허 학습 로직으로 학습합니다.",
    ],
  };

  const cardSectionData3 = {
    title: "유의어 학습",
    description: "비슷한 단어들을 내것으로!",
    emoji: "🔤",
    listItems: [
      "공무원 시험을 대비하여 유의어들을 학습합니다.",
      "객관식, 주관식 단어를 공무원 시험 대비 단어장의 단어들을 학습",
      "특허 학습 로직으로 학습합니다.",
    ],
  };

  const cardSectionData4 = {
    title: "모르는 단어 학습",
    description: "모르는 단어를 익히자!",
    emoji: "📝",
    listItems: [
      "보카 톡톡의 특허 받은 자동 메타인지를 통한 모르는 단어를 빠르게 아는 단어로 만드는 학습을합니다.",
      "객관식, 주관식 모르는 단어를 학습하여 아는 단어로 만드는 학습을합니다.",
    ],
  };

  const cardSectionData5 = {
    title: "만든 단어 학습",
    description: "원하는 단어도 학습로직 그대로!",
    emoji: "📖",
    listItems: [
      "선생님들이 만든 단어 데이터를 서버에 올려 우리 학생들만 학습할 수 있는 학습입니다.",
      "객관식, 주관식 단어를 학습하여 선생님이 원하는 과정을 최소시간으로 최대 결과치가 나올 수 있게 학습합니다.",
    ],
  };

  return (
    <section className="bg-gray-200 dark:bg-gray-700">
      <div className="max-w-screen-xl px-4 py-8 mx-auto lg:py-24 lg:px-6">
        <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
          <h2 className="mb-4 text-3xl sm:text-5xl font-extrabold tracking-tight text-gray-900 dark:text-white">
            단어의 습관을 위해선 보카톡톡!
          </h2>

          <div className=" pt-10 font-bold text-gray-600 sm:text-xl dark:text-gray-400">
            준비가 되었다면?
          </div>
          <a
            href="https://chamstudyland.com/vokok/desktop/login.php"
            target="_blank"
            className="mt-3 font-bold inline-block w-auto text-center min-w-[200px] px-6 py-4 text-white transition-all rounded-md shadow-xl sm:w-auto bg-gradient-to-r from-orange-600 to-orange-500 hover:bg-gradient-to-b dark:shadow-orange-900 shadow-orange-200 hover:shadow-2xl hover:shadow-orange-400 hover:-tranneutral-y-px "
          >
            보카톡톡 학습하러가기!
          </a>
        </div>
        <Logo textArray={textArray} />
        <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
          <h2 className="pt-10 mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
            보카톡톡이란?
          </h2>
          <p className="mb-5 text-gray-600 font-bold sm:text-xl dark:text-gray-400">
            ✿ 특허 7건 등록
            <br /> ✿ ‘완전학습이론으로 설계..‘ <br />
            박사 논문으로 검증
          </p>
          <p className="mb-5 text-gray-600 font-bold sm:text-xl dark:text-gray-400">
            ╰(✿´⌣`✿)╯특허받은 자동 메타인지 학습 로직을 적용한 <br />
            '보카톡톡’
          </p>
        </div>

        <CardText title={cardData.title} items={cardData.items} />

        <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
          <h2 className="pt-10 mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
            더 자세하게 알아보기
          </h2>
          <p className="mb-5 text-gray-600 font-bold sm:text-xl dark:text-gray-400">
            보카톡톡 단어 학습은 테스트 복습, 선택학습 학습, 유의어 학습, 모르는
            단어 학습, 생성데이터학습, 즐거운 학습 등의 다양한 학습을 통해
            자연스럽게 장기 기억 시키는 학습을 합니다.
          </p>
        </div>

        <CardText title={cardData2.title} items={cardData2.items} />

        <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
          <h2 className="pt-10 mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
            ✿ 보카톡톡 단어의 학습 종류
          </h2>
          <p className="mb-5 text-gray-600 font-bold sm:text-xl dark:text-gray-400">
            보카톡톡 단어 학습은 테스트 복습, 선택학습 학습, 유의어 학습, 모르는
            단어 학습, 생성데이터학습, 즐거운 학습 등의 다양한 학습을 통해
            자연스럽게 장기 기억 시키는 학습을 합니다.
          </p>
        </div>

        <div className="space-y-8 lg:grid lg:grid-cols-3 sm:gap-6 xl:gap-10 lg:space-y-0">
          <CardSectionNotOnClick {...cardSectionData1} />
          <CardSectionNotOnClick {...cardSectionData2} />
          <CardSectionNotOnClick {...cardSectionData3} />
          <CardSectionNotOnClick {...cardSectionData4} />
          <CardSectionNotOnClick {...cardSectionData5} />
        </div>
      </div>
    </section>
  );
};

export default Vokatoktok;
